<template>
  <md-button
    class="md-just-icon md-danger md-simple text-right"
    title="Delete"
    @click="deleteMeter()"
    style="margin-right: 10px;"
  >
    <md-icon>close</md-icon>
  </md-button>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { getStatus } from "@/globalMethods";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  props: {
    ID: {
      type: Number,
      default: 0
    },
    deviceMAC: {
      type: String,
      default: ""
    }
  },
  methods: {
    wrapper_getStatus() {
      return getStatus(this.deviceMAC);
    },

    deleteMeter() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: "OK",
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            return axios({
              method: "DELETE",
              url: this.$ENDPOINTS.API_W + "/applied-precision/meters",
              data: {
                device_token: getSelectedDeviceToken(this.deviceMAC),
                ID_meter: this.ID
              },
              withCredentials: true
            })
              .then(() => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.success,
                  text: this.$lang.messages.success_removed_device,
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                });
              })
              .then(response => {
                this.$emit("onFinish");
              })
              .catch(error => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    }
  }
};
</script>